<template>
  <div>
    <Header></Header>
    <div class="magezineCon">
      <div class="top">
        <div class="title">MAGAZINE</div>
      </div>
      <div class="center">
        <router-link to="/magezinein">
          <div class="con">
            <div class="m_img" v-for="item,index in items" :key="index">
                <router-link :to="{name:'/magazine',params:{magazine:item.title}}">
                  <img :src="item.cover" alt="" />
                </router-link>
            </div>
          </div>
        </router-link>
      </div>
      <div class="bottom">
        <div class="menu">
          <div class="menuItem" v-for="(item, index) in array" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header_M.vue'
export default{
  components:{
      Header
  },
  data() {
    return {
      array: ["A", "B", "C", "D", "H", "O"],
      items:[]
    };
  },
  mounted() {
    this.scrollInit()
    this.getData()
  },
  methods: {
    async getData() {
      const magazine = await this.$axios.get("magazine", {
      });
      this.items = magazine.data;
    },
  // 初始化与绑定监听事件方法
 	scrollInit() {
 	  // 获取要绑定事件的元素
      const scrollDiv = document.getElementsByClassName("center")[0];
      scrollDiv.addEventListener('mousewheel', handler, false)
      function handler(event) {
        const detail = event.wheelDelta || event.detail;
        const moveForwardStep = 1;
        const moveBackStep = -1;
        let step = 0;
        if (detail < 0) {
          step = moveForwardStep * 50;
        } else {
          step = moveBackStep * 50;
        }
        scrollDiv.scrollLeft += step;
      }
    }
  }
};
</script>
<style scoped>
.magezineCon {
  width: 100%;
  height: 100vh;
  padding-top: 50px;
  background-color: #000;
}
::-webkit-scrollbar {
  display: none;
}
.magezineCon .top {
    padding: 10px;
  z-index: 2;
}
.magezineCon .top .title {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
}
.magezineCon .center {
  width: 100%;
  height: 50%;
  top: 25%;
  position: fixed;
  overflow-x: auto;
  overflow-y: hidden;
}
.magezineCon .center .con{
  width: fit-content;
  height: 100%;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.magezineCon .center .con .m_img{
    width: 100vw;
    height: inherit;
    display: inline-block;
    box-sizing: content-box;
    text-align: center;
}
.magezineCon .center .con .m_img img {
  width: inherit;
  height: inherit;
  object-fit: contain;
}
.magezineCon .bottom {
  width: 100%;
  height: 3vh;
  position: fixed;
  bottom: 3vh;
}
.magezineCon .bottom .menu {
  width: fit-content;
  height: inherit;
  margin: 0 auto;
}
.magezineCon .bottom .menu .menuItem {
  width: 3vh;
  height: 3vh;
  line-height: 3vh;
  padding: 0 1vh;
  color: #fff;
  display: inline-block;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  border-radius: 1.5vh;
}
.magezineCon .bottom .menu .menuItem:hover {
  background-color: #fff;
  color: #000;
}
.magezineCon .bottom .menu .menuItem:active {
  background-color: #fff;
  color: #000;
}
</style>


// WEBPACK FOOTER //
// src/view/mobile/AllMagazine.vue